import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import { IconTile, Message, Root } from './IconEmptyState.styles';

export type IconEmptyStateProps = {
  /** Icon node rendered inside the rounded tile (size it at the call site). */
  icon: ReactNode;
  /** Centered, muted message below the icon. */
  message: ReactNode;
  /** Optional action rendered below the message (e.g. a create button/menu). */
  action?: ReactNode;
  className?: string;
  'data-testid'?: string;
};

/**
 * Shared "nothing here yet" placeholder: a rounded icon tile, a muted message
 * and an optional action. Transparent and compact — it hugs its content and is
 * sized by its parent. Used by the request view, the aside and block sections so
 * they stay visually consistent.
 */
export default function IconEmptyState({
  icon,
  message,
  action,
  className,
  'data-testid': dataTestId,
}: IconEmptyStateProps) {
  return (
    <Root className={className} data-testid={dataTestId}>
      <Stack width='100%' minWidth={0} spacing={2} alignItems='center'>
        <IconTile>{icon}</IconTile>
        <Message variant='body2'>{message}</Message>
      </Stack>
      {action}
    </Root>
  );
}
